// Look of the app: "glass" (Apple-style liquid glass, default) or "classic".
// Saved per device; applied as <html data-theme="…"> while the app is open.

const KEY = "invoice-studio-theme";
export const THEMES = [
  { value: "glass", label: "Liquid glass", hint: "Frosted, translucent panels over a soft colour backdrop" },
  { value: "classic", label: "Classic", hint: "Solid white panels – plain and fast" },
];

export function getTheme() {
  try {
    return localStorage.getItem(KEY) === "classic" ? "classic" : "glass";
  } catch {
    return "glass";
  }
}

export function applyTheme(theme = getTheme()) {
  if (typeof document !== "undefined") document.documentElement.dataset.theme = theme;
}

export function setTheme(theme) {
  try {
    localStorage.setItem(KEY, theme);
  } catch {}
  applyTheme(theme);
  window.dispatchEvent(new CustomEvent("invoice-theme", { detail: theme }));
}
